import React from 'react'
import { IVehicleDetails } from '../types/interfaces'
import { useTranslation } from 'react-i18next'

export default function SingleVehicleInfo({ data }: {data: IVehicleDetails}) {
  const {i18n} = useTranslation()
  const infoData = [
    {title: "Stockbook #", value: data?.stockbook_number},
    {title: "Chassis", value: data?.chassis},
    {title: "Brand", value: data?.variant?.vehicle_model?.vehicle_make?.name},
    {title: "Model", value: data?.variant?.vehicle_model?.name},
    {title: "Variant", value: data?.variant?.display_name?.[`${i18n.language as 'ar' | 'en'}`]},
    {title: "Type", value: data?.type},
    {title: "Interior Color", value: data?.interior_color?.display_name?.[`${i18n.language as 'ar' | 'en'}`]},
    {title: "Exterior Color", value: data?.exterior_color?.display_name?.[`${i18n.language as 'ar' | 'en'}`]},
    {title: "Vehicle Price", value: data?.price?.toLocaleString('en-US')},
    {title: "Owner", value: data?.user?.first_name},
  ]

  return (
    <div className='vehicle-details'>
      {infoData?.map((item, index) => (
        <div className='vehicle-details_item' key={`vehicle-details-item-${index}`}>
          <span className='vehicle-details_item_title'>{item?.title}:</span>
          <span className='vehicle-details_item_value capitalize'>{item?.value || "---"}</span>
        </div>
      ))}
    </div>
  )
}
